export default __webpack_public_path__ + "static/media/Vambraces of Black Spite.671d1123.jpg";